import { SIcon } from '@strana-artw/ui-kit';
export default {
  name: 'ManualLink',
  components: {
    SIcon: SIcon
  },
  props: {
    label: {
      type: String,
      default: undefined
    },
    link: {
      type: String,
      default: undefined
    }
  }
};